import React from "react";
import {
    BrowserRouter as Router,
    Switch
} from "react-router-dom";

import AsyncComponent from "../AsyncComponent";

import GuestRoute from "../GuestRoute";

const Verify = AsyncComponent(() => import("../../screens/Verify"));

const IframePlayer = AsyncComponent(() => import('../../screens/IframePlayer'));
const Survey = AsyncComponent(() => import('../../screens/Survey'));

const ViewerZoneContainer = AsyncComponent(() => import("../../screens/ViewerZone/ViewerZoneContainer"));


const RouterComponent = ({ process, currentUser, authenticated, onRequestLoading, onLogout, auth }) => {
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <div className="az-body">
                <Switch>
                    <GuestRoute exact path="/feedback/:id"
                        authenticated={authenticated}
                        currentUser={currentUser}
                        onLogout={onLogout}
                        noRedirect
                        component={Survey} />

                    <GuestRoute exact path="/iframe/:organizer/:event_name"
                        authenticated={authenticated}
                        currentUser={currentUser}
                        onLogout={onLogout}
                        noRedirect
                        component={IframePlayer} />

                    <GuestRoute exact path="/:organizer/:event_name"
                        authenticated={authenticated}
                        currentUser={currentUser}
                        onLogout={onLogout}
                        noRedirect
                        component={ViewerZoneContainer} />

                    <GuestRoute component={Verify} onLogout={onLogout} auth={auth} onRequestLoading={onRequestLoading} />
                </Switch>
            </div>
        </Router>
    )
}

export default RouterComponent;
